<template>
  <BaseDialog :visible="show" dialogClass="md:!w-[600px] !w-[300px]">
    <div class="rounded-lg w-full md:p-[20px] p-[10px]">
      <div class="flex items-center justify-center w-full">
        <div
          class="rounded-full md:p-[20px] p-[10px]"
          v-html="deleteAccountSvg({})"
          style="
            background: linear-gradient(
                0deg,
                rgb(255, 234, 225),
                rgb(255, 234, 225)
              ),
              linear-gradient(
                315deg,
                rgba(251, 143, 0, 0) 11.89%,
                rgba(251, 143, 0, 0.2) 86.59%
              );
          "
        ></div>
      </div>

      <div class="md:py-[20px] py-[10px] text-center">
        <p class="md:text-[20px] text-[14px] font-just font-[600]">
          {{ $t('wishesLabel.unsavedChanges') }}
        </p>
      </div>
      <div class="md:pb-[20px] pb-[10px]">
        <p class="font-just md:text-[16px] text-[12px] font-[500]">
          {{ $t('wishesLabel.unsavedChangesDescription') }}
        </p>
      </div>

      <div class="flex justify-center items-center gap-[10px]">
        <BaseButton
          @click="$emit('cancel')"
          class="px-4 py-2 !bg-transparent !border-solid !border-[1px] !text-black w-full whitespace-nowrap md:!text-[16px] !text-[10px] md:!h-[48px] !h-[35px]"
          :label="$t('commonLabels.cancel')"
        />
        <BaseButton
          @click="$emit('confirm')"
          class="!bg-btnDisActive !border-solid !border-[1px w-full whitespace-nowrap !text-white md:!text-[16px] !text-[10px] md:!h-[48px] !h-[35px]"
          :label="$t('wishesLabel.leaveWithoutSaving')"
        />
      </div>
    </div>
  </BaseDialog>
</template>

<script setup>
import { deleteAccountSvg } from "@/utils/commonSvg";
import BaseDialog from "./BaseDialog.vue";
defineProps({
  show: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["confirm", "cancel"]);
</script>
